import {useQuery} from '@tanstack/react-query'
import {getNotice} from '../../api/notices'
import {queryKeys} from '../../constants/queryKey'

function useGetNoticeQuery({id}: {id: number}) {
  return useQuery<INotice>([queryKeys.notices], () => getNotice({id}), {})
}

export default useGetNoticeQuery
